import { render, staticRenderFns } from "./TermsAndConditionsILP.vue?vue&type=template&id=4243aa43&scoped=true&"
import script from "./TermsAndConditionsILP.vue?vue&type=script&lang=js&"
export * from "./TermsAndConditionsILP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4243aa43",
  null
  
)

export default component.exports